import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TResolveWorkersByExternalIdsRequestSchema,
  TResolveWorkersByExternalIdsResponseSchema,
} from "./resolveWorkersByExternalIds.schema";

export const resolveWorkersByExternalIds = (axios: IAxiosInstance) => {
  return async (requestBody: TResolveWorkersByExternalIdsRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TResolveWorkersByExternalIdsResponseSchema>
    >(`/api/workers/resolve-by-external-ids`, requestBody);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
